import { useEffect, useState } from "react"

import { FieldData, mapFilters } from "@/components/_Shared/FilterWrapper"

import { useDepotSelectListQuery } from "@/hook/Dictionaries/useDepotQuery"
import { useFuelTypeQuery } from "@/hook/Dictionaries/useFuelTypeQuery"
import { useFilterStorage } from "@/hook/useFilterStorage"

import { FUEL_QUOTES_ARCHIVE_KEY } from "@/types/IFuelQuote"
import { FilterField, FilterFieldType } from "@/types/ui"


export const useFuelArchiveFilters = () => {
  const [filters, setFilters] = useState<FilterField[]>([])

  const { getFilter } = useFilterStorage({
    key: FUEL_QUOTES_ARCHIVE_KEY
  })

  const oldFilters: FieldData[] = getFilter()

  const { data: depots } = useDepotSelectListQuery()
  const { data: fuelTypes } = useFuelTypeQuery()

  useEffect(() => {
    setFilters([
      {
        text: "Нефтебаза",
        name: "depotId",
        type: FilterFieldType.Select,
        values: depots?.response.map((f) => ({
          id: f.id,
          name: f.name
        })) ?? []
      },
      {
        text: "Тип топлива",
        name: "fuelTypeId",
        type: FilterFieldType.Select,
        values: fuelTypes?.response.data.map((f) => ({
          id: f.id,
          name: f.name
        })) ?? []
      },
      ...FuelArchiveFilters
    ])
  }, [depots, fuelTypes])

  return mapFilters(filters, oldFilters)
}

const FuelArchiveFilters: FilterField[] = [
  {
    text: "Дата",
    name: "date",
    type: FilterFieldType.DateRange
  },
  {
    text: "Плотность",
    name: "density",
    type: FilterFieldType.NumberWithOperator,
    equalAccuracy: 3
  },
  {
    text: "Цена реализации",
    name: "sellingPrice",
    type: FilterFieldType.NumberWithOperator
  }
]